
import * as React from 'react'
import { Image, Text, View, ScrollView, TouchableOpacity } from 'react-native'
import images from '../../assets/images'
import { useTheme } from '@react-navigation/native'
import numeral from 'numeral'
import { AnimatedCircularProgress } from './CircularProgress';
import Axios from 'axios'
import { RefreshControl } from 'react-native-web-refresh-control'

export default React.memo(function DailyStatistics({ month_string }) {
    const { colors } = useTheme()
    const [data, setData] = React.useState()
    const [refreshing, setRefreshing] = React.useState(true)
    const MAX_POINTS = 100;

    React.useEffect(() => {
        setRefreshing(true)
        Axios.get(`api/ceo/customer/index?date=${month_string}`)
            .then(res => {
                console.log(res)
                if (res.status === 200)
                    setData(res.data)
                setRefreshing(false)
            }).catch(err => {
                setRefreshing(false)
                console.log(err)
            })
    }, [month_string])

    const getColorProgress = (value) => {
        try {
            if (value < 50) return colors.process_3
            else if (value < 75) return colors.process_1
            else return colors.process_2
        } catch (error) {
        }
    }

    const getColorText = (value) => {
        try {
            if (value < 50) return colors.text_red
            else if (value < 75) return colors.text_yellow
            else return colors.text_green
        } catch (error) {
        }
    }

    const onRefresh = () => {
        setRefreshing(true)
        Axios.get(`api/ceo/customer/index?date=${month_string}`)
            .then(res => {
                if (res.status === 200) {
                    setData(res.data)
                }
                setRefreshing(false)
            }).catch(err => {
                setRefreshing(false)
                console.log(err)
            })
    }

    const changeStar = (point, value) => {
        let checkPointMoreHalf = value - 0.25;
        let checkPointHalf = value - 0.5;
        let checkPointQuarter = value - 0.75;
        if (point >= value) {
            return images.icons.star_full;
        } else {
            if (point >= checkPointMoreHalf) {
                return images.icons.star_more_half;
            } else if (point >= checkPointHalf) {
                return images.icons.star_half;
            } else if (point >= checkPointQuarter) {
                return images.icons.star_quarter;
            }
        }
        return images.icons.star_empty;
    }

    const renderStar = (val) => {
        return <View style={{ alignItems: 'center', justifyContent: 'center', zIndex: 999, position: 'absolute', bottom: 20 }}>
            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                <Image source={changeStar(val, 1)} style={{ height: 40, width: 40, resizeMode: 'contain', marginHorizontal: 11 }} />
                <Image source={changeStar(val, 2)} style={{ height: 40, width: 40, resizeMode: 'contain', marginHorizontal: 11 }} />
                <Image source={changeStar(val, 3)} style={{ height: 40, width: 40, resizeMode: 'contain', marginHorizontal: 11 }} />
                <Image source={changeStar(val, 4)} style={{ height: 40, width: 40, resizeMode: 'contain', marginHorizontal: 11 }} />
                <Image source={changeStar(val, 5)} style={{ height: 40, width: 40, resizeMode: 'contain', marginHorizontal: 11 }} />
            </View>
            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 24, color: colors.text, paddingTop: 6 }}>{val} / 5</Text>
        </View>
    }
    const fill = (data?.range_customer_satisfied / MAX_POINTS) * 100;
    return (
        <ScrollView style={{ flex: 1 }} refreshControl={<RefreshControl refreshing={refreshing} onRefresh={onRefresh} tintColor={colors.text} colors={[colors.text]} />}>
            {
                data ? <>
                    <View style={{ backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15, paddingBottom: 10 }}>
                        <View style={{ marginTop: 8, flexDirection: 'column', alignItems: 'center' }}>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 13, color: colors.text }}>TỔNG SỐ KHÁCH HÀNG</Text>

                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 36, color: colors.text }}>{data?.total_customer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                <Image source={images.icons.icon_arrow_up} style={{ height: 10, width: 10, resizeMode: 'contain', paddingHorizontal: 6 }} />
                                <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 14, color: colors.text_sub }}>tăng </Text>
                                <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 14, color: colors.text_green }}>{data?.total_customer_in_month.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                                <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 14, color: colors.text_sub }}> so với tháng trước</Text>
                            </View>

                        </View>

                    </View>

                    <View style={{ backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15, alignItems: 'center', justifyContent: 'center', paddingTop: 10 }}>
                        <AnimatedCircularProgress
                            size={260}
                            width={20}
                            backgroundWidth={20}
                            fill={fill}
                            tintColor={getColorProgress(data?.range_customer_satisfied)}
                            backgroundColor={colors.process_background}
                            arcSweepAngle={180}
                            rotation={270}
                            lineCap="round">
                            {
                                (fill) => (
                                    <View style={{ alignItems: 'center', justifyContent: 'center', marginBottom: 60 }}>
                                        <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 36, color: getColorText(data?.range_customer_satisfied) }}>{numeral(fill / 100).format('0.0%')}</Text>
                                        <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 14, color: colors.text_sub }}>Khách hàng hài lòng</Text>
                                    </View>
                                )
                            }
                        </AnimatedCircularProgress>
                        {renderStar(numeral(fill / 20).format('0.00'))}
                    </View>

                    <View style={{ backgroundColor: 'white', marginHorizontal: 12, marginTop: 18, borderRadius: 10, paddingHorizontal: 15 }}>
                        <View style={{ marginTop: 8, flexDirection: 'column', alignItems: 'center' }}>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 15, color: colors.text }}>Số lỗi trong tháng</Text>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 36, color: colors.text_orange }}>{data?.error_in_month}</Text>

                        </View>
                        <View style={{ marginBottom: 4 }}>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 14, color: colors.text_sub }}>đã xử lý <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 14, color: colors.text }}>{data?.error_has_fixed} </Text>lỗi</Text>
                        </View>
                        <View style={{ flexDirection: 'row', marginBottom: 16, alignItems: 'center', alignContent: 'center' }}>
                            <Text style={{ fontFamily: 'Nunito_700Bold', fontSize: 14, color: colors.text, paddingRight: 12 }}>{data?.error_has_fixed == 0 ? 0 : numeral(data?.error_has_fixed * 100 / data?.error_in_month).format('0.0')}%</Text>
                            <View style={{
                                height: 10, position: 'relative', flex: 1, backgroundColor: colors.process_background, borderRadius: 3,
                                justifyContent: 'center'
                            }}>
                                <View style={{
                                    position: 'absolute', top: 0, left: 0, width: `${data?.error_has_fixed == 0 ? 0 : numeral(data?.error_has_fixed * 100 / data?.error_in_month).format('0.0')}%`,
                                    height: '100%', backgroundColor: getColorProgress(data?.error_has_fixed == 0 ? 0 : data?.error_has_fixed * 100 / data?.error_in_month), borderRadius: 3
                                }} />
                            </View>
                        </View>
                    </View>
                    <View style={{ marginBottom: 16 }} />
                </> : (
                        !refreshing ? <View style={{ marginTop: 80, flexDirection: 'column', alignItems: 'center' }}>
                            <Image source={images.server_error} style={{ width: 200, height: 200 }} />
                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', marginTop: 24, fontSize: 18 }}>Đã có lỗi xảy ra</Text>
                            <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>Vui lòng ấn nút bên dưới để thử lại</Text>
                            <TouchableOpacity onPress={onRefresh}>
                                <Image source={images.refresh} style={{ width: 40, height: 40, marginTop: 16 }} />
                            </TouchableOpacity>
                        </View> : null
                    )
            }
        </ScrollView>
    );
})